import { Box, Tag, Tooltip } from "@chakra-ui/react";
import React from "react";

const CustomCard = React.forwardRef(({ children, ...rest }, ref) => (
  //   <Box p="1">
  <Tag ref={ref} {...rest} p={0} m={0} bg={"transparent"}>
    {children}
  </Tag>
  //   </Box>
));

const CustomToolTip = React.memo( ({ button, mess }) => {
  return (
    <Tooltip label={mess} hasArrow>
      <CustomCard>{button}</CustomCard>
    </Tooltip>
  );
});

// render(<CustomToolTip />);
export default CustomToolTip;
